/*
 * @Author: chenkailun
 * @Date: 2025-02-12 15:59:31
 * @LastEditors: chenkailun
 * @LastEditTime: 2025-03-04 14:10:47
 * @Description: 
 * @FilePath: \solarbiolite\src\api\user.js
 */
import { fetchEndpoint } from '../server/network'

// 注册字段
export const userProfileFields = () => fetchEndpoint('/v2/ecapi.user.profile.fields', 'POST', {})

// 获取用户资料
export const userProfileGet = () => fetchEndpoint('/v2/ecapi.user.profile.get', 'POST', {})

// 修改用户资料
export const userProfileUpdate = (values, gender, nickname, avatar_url) =>
	fetchEndpoint('/v2/ecapi.user.profile.update', 'POST', {
		values: values,
		gender: gender, // 性别
		nickname: nickname, // 昵称
		avatar_url: avatar_url // 用户头像
	})

// 修改用户密码
export const userPasswordUpdate = (old_password, password) =>
	fetchEndpoint('/v2/ecapi.user.password.update', 'POST', {
		old_password: old_password, // 旧密码
		password: password // 新密码
	})
	
//我的券包
export const userTicket = () => fetchEndpoint('/v2/ecapi.ticket.list', 'POST', {})

//我的卡包
export const userCardBag = () => fetchEndpoint('/v2/ecapi.card.bag', 'POST')

//我的收藏
export const userEnshrine = () => fetchEndpoint('/v2/ecapi.enshrine.list', 'POST', {})

//浏览历史数据
export const userHistory = (data) =>
	fetchEndpoint('/v2/ecapi.history.list', 'POST', {
		goods_ids:data
	})


//检测当前IP
export const getClientIp = () => fetchEndpoint('/v2/ecapi.user.ip', 'POST', {})	



// WEBPACK FOOTER //
// ./src/api/user.js